import { EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Utility } from './../../Common/Services/utility';
/** How to Use
 * pass formControlName and isDisable property with component.
 * Syntex:  <custom-time-control formControlName="examLength" [isDisable]="disableField"></custom-time-control>
 */
var CustomTimeControlComponent = (function () {
    function CustomTimeControlComponent(_utility) {
        this._utility = _utility;
        this.dateFormatOptions = ['AM', 'PM'];
        this.configModel = {
            hhMin: 0,
            hhMax: 23,
            hhShow: true,
            mmMin: 0,
            mmMax: 59,
            mmShow: true,
            ssMin: 0,
            ssMax: 59,
            ssShow: false,
            format: 24 // for 24 hours pass 24 & for 12 hours format pass 12 
        };
        this.isControlDisable = false;
        this.defaultTime = "0:0";
        this.showTimerIcon = true;
        this.change = new EventEmitter(); // In Case you have a need to add change event in your parent Component you can use it.
        this.onChange = function () { };
        this.onTouched = function () { };
        if (this.configModel.format == 12) {
            this.configModel.hhMax = 11;
        }
    }
    /**
     *
     * @param changes - If property binding changes occurred, this method will be called
     */
    CustomTimeControlComponent.prototype.ngOnChanges = function (changes) {
        var value = changes.isControlDisable ? changes.isControlDisable.currentValue : '';
        if (this.form) {
            if (value) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        }
    };
    CustomTimeControlComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form = new FormGroup({
            hh: new FormControl('0', [Validators.required, Validators.min(this.configModel.hhMin), Validators.max(this.configModel.hhMax), Validators.maxLength(this.configModel.hhMax.toString().length)]),
            mm: new FormControl('0', [Validators.required, Validators.min(this.configModel.mmMin), Validators.max(this.configModel.mmMax), Validators.maxLength(this.configModel.mmMax.toString().length)]),
            ss: new FormControl('0', [Validators.required, Validators.min(this.configModel.ssMin), Validators.max(this.configModel.ssMax), Validators.maxLength(this.configModel.ssMax.toString().length)]),
            format: new FormControl('')
        });
        this.control = this.form.controls;
        this.form.valueChanges
            .debounceTime(50)
            .distinctUntilChanged()
            .subscribe(function (form) {
            _this.onValueChange();
        });
        if (this.isControlDisable) {
            this.form.disable();
        }
        else {
            this.form.enable();
        }
    };
    Object.defineProperty(CustomTimeControlComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    CustomTimeControlComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Write value method
     * If format is selected 12 hours then convert incoming-time into 12 hours
     * @param value Write value on field when it comes in control
     */
    CustomTimeControlComponent.prototype.writeValue = function (value) {
        if (!value)
            value = this.defaultTime;
        if (value) {
            this.value = value;
            var arr = [value];
            if (this.configModel.format == 12) {
                value = this.convertTimeIn12hrs(value);
                arr = value.split(' ');
                this.control.format.setValue(arr[1]); // set AM, PM
            }
            var arrTime = arr[0].split(':');
            this.control.hh.setValue((arrTime.length > 0 && arrTime[0] != "" && Number(arrTime[0]) < 10) ? arrTime[0].slice(-1) : (arrTime[0] != "") ? arrTime[0] : 0);
            this.control.mm.setValue((arrTime.length > 1 && arrTime[1] != "" && Number(arrTime[1]) < 10) ? arrTime[1].slice(-1) : (arrTime[1] != "") ? arrTime[1] : 0);
            this.control.ss.setValue((arrTime.length > 2 && arrTime[2] != "" && Number(arrTime[2]) < 10) ? arrTime[2].slice(-1) : (arrTime[2] != "") ? arrTime[2] : 0);
        }
    };
    CustomTimeControlComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    CustomTimeControlComponent.prototype.onValueChange = function () {
        this.value = this.getResult();
        this.change.emit(this.value);
    };
    CustomTimeControlComponent.prototype.onBlur = function (field) {
        this.checkForValid();
    };
    /**
     * It returns hours and minutes after append it by colon (:)
     */
    CustomTimeControlComponent.prototype.getResult = function () {
        this.checkForValid();
        var values = this.form.getRawValue();
        var tempValue = '';
        if (this.configModel.hhShow && values.hh != null) {
            tempValue = ('0' + values.hh).slice(-2);
        }
        if (this.configModel.mmShow && values.mm != null) {
            tempValue += (tempValue == '' ? ('0' + values.mm).slice(-2) : ':' + ('0' + values.mm).slice(-2));
        }
        if (this.configModel.ssShow && values.ss != null) {
            tempValue += (tempValue == '' ? ('0' + values.ss).slice(-2) : ':' + ('0' + values.ss).slice(-2));
        }
        if (this.configModel.format == 12) {
            tempValue += " " + values.format;
        }
        if (tempValue == '') {
            tempValue = "00:00";
        }
        if (this.configModel.format == 12) {
            tempValue = this.convertTimeIn24hrs(tempValue);
        }
        return tempValue;
    };
    /**
     * Check for hours, minutes and seconds invalid.
     * If there are invalid for min value or max value , then set default value
     * IF field is blank with no data then set 0 into that field
     */
    CustomTimeControlComponent.prototype.checkForValid = function () {
        var hours = this.control.hh;
        if (hours.invalid) {
            var temphh = (hours.errors.min) ? this.configModel.hhMin : hours.errors.max ? this.configModel.hhMax : '0';
            hours.setValue(temphh);
        }
        else {
            hours.setValue(hours.value);
        }
        var minutes = this.control.mm;
        if (minutes.invalid) {
            var tempmm = (minutes.errors.min) ? this.configModel.mmMin : minutes.errors.max ? this.configModel.mmMax : '0';
            minutes.setValue(tempmm);
        }
        else {
            minutes.setValue(minutes.value);
        }
        var seconds = this.control.ss;
        if (seconds.invalid) {
            var tempss = (seconds.errors.min) ? this.configModel.ssMin : seconds.errors.max ? this.configModel.ssMax : '0';
            seconds.setValue(tempss);
        }
    };
    CustomTimeControlComponent.prototype.convertTimeIn24hrs = function (time) {
        var hours = Number(time.match(/^(\d+)/)[1]);
        var minutes = Number(time.match(/:(\d+)/)[1]);
        var finalTime = time;
        if (time.match(/\s(.*)$/)) {
            var AMPM = time.match(/\s(.*)$/)[1];
            if (AMPM == "PM" && hours < 12)
                hours = hours + 12;
            if (AMPM == "AM" && hours == 12)
                hours = hours - 12;
            finalTime = hours.toString() + ":" + minutes.toString();
        }
        return finalTime;
    };
    CustomTimeControlComponent.prototype.convertTimeIn12hrs = function (time) {
        // Check correct time format and split into components
        time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
        if (time.length > 1) {
            time = time.slice(1); // Remove full string match value
            time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join(''); // return adjusted time or original string
    };
    return CustomTimeControlComponent;
}());
export { CustomTimeControlComponent };



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/custom-time-control/custom-time-control.component.ts.pre-build-optimizer.js